import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'

import BannerTile from 'components/BannerTile'
import useBuilderCMSData from 'src/hooks/useBuilderCMSData'
import { useAppSelector } from 'src/store/hooks'
import { getIsAdminOnlyPromoContentSelector } from 'src/store/modules/user/selectors'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'

const PROMOTION_BANNERS_FROM_BUILDER = process.env.CMS_DATA_MODEL_PROMOTIONS_HOMEPAGE_BANNERS

export type BannerProps = {
  data: {
    url: string
    src: string
    alt: string
    dataTest: string
    adminOnly?: boolean
  }
}

export default function PromoBannersFromBuilder() {
  const { builderData: promoBanners } = useBuilderCMSData(PROMOTION_BANNERS_FROM_BUILDER)
  const isAdminOnlyPromoCallback = useAppSelector(getIsAdminOnlyPromoContentSelector)
  const onClickHandler = (category: string) => {
    nextTick().then(() => trackEvent('clicked_on_banner', { category }))
  }

  return (
    <>
      {promoBanners.map((el: BannerProps) => {
        const {
          data: { src, url, dataTest, alt, adminOnly },
        } = el
        const bannerUrl = generateImageUrl(src, ImagesDirectory.BANNERS)
        const isAdminOnlyPromo = isAdminOnlyPromoCallback(adminOnly)

        if (isAdminOnlyPromo) {
          return null
        }

        return (
          <BannerTile
            key={dataTest}
            url={url}
            onClick={() => onClickHandler(dataTest)}
            src={bannerUrl}
            alt={alt}
            dataTest={dataTest}
          />
        )
      })}
    </>
  )
}
